// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import newComment from 'images/new-comment.png'
import { useShowNewCommentModal } from './hooks'

const NewComment = props => {
  const { idRoot } = props

  const handleClick = useShowNewCommentModal(props)

  return (
    <div className={'position-relative'}>
      <img
        alt={'new-comment-trigger'}
        src={newComment}
        title={'new-comment-trigger'} />
      <p
        className={'new-comment-trigger'}
        id={`${idRoot}-new-comment-modal-toggle`}
        onClick={handleClick} />
    </div>
  )
}

NewComment.propTypes = {
  createCallback: func.isRequired,
  idRoot: string.isRequired,
  pathComment: bool,
}

export default NewComment
